// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_d7-2";
export var aiChatCartContainerExit = "_d7-4";
export var aiChatContainerLarge = "_d7-0";
export var aiChatContainerSmall = "_d7-1";
export var aiChatIcon = "_d7-6";
export var slideInFromRight = "_d7-3";
export var slideOutToRight = "_d7-5";